import { ipaUrl } from '@/constants';

export const BFF_BASE_URL = `${ipaUrl}/bff`;

export const BffEndpoints = {
  ITERABLE_SUBSCRIPTION: '/iterable/subscriptions',
  ITERABLE_UPDATE_SUBSCRIPTION: '/iterable/update-subscriptions',
  CUSTOM_CERTIFICATE: '/tracker/external-certificate',
} as const;
